<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Parts Manual URL Management</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-list-alt"></i>
                    <span>Parts Manual URL Management</span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container">
    <partsmanual-list></partsmanual-list>
</div>